export function HkdPriceLabel({ priceHkd }: { priceHkd: string | null }) {
  if (!priceHkd || priceHkd === "0" || priceHkd === "NAN") return null;
  return (
    <div style={{ color: "#999", fontSize: 12, marginTop: -10 }}>
      转换为 HKD:{" "}
      {parseFloat(priceHkd).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </div>
  );
}
